import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  spaceXXL,
  space3XL,
  scale000,
  spaceXL,
  spaceL,
} from '@xing-com/tokens';
import { BodyCopy, Hero } from '@xing-com/typography';

const StyledHero = styled(Hero)`
  margin: ${space3XL} ${scale000} ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin: ${spaceXXL} ${scale000} ${spaceXL};
  }
`;

const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: ${spaceXL};
  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceL};
  }
`;

export const Styled = {
  Hero: StyledHero,
  BodyCopy: StyledBodyCopy,
};
